import agency from './agency';
import park from './park';
import driver from './driver';
import vehicle from './vehicle';
import stop from './stop';
import route from './route';
import department from './department';
import controlregion from './controlregion';

export default {
  agency,
  park,
  driver,
  vehicle,
  stop,
  route,
  department,
  controlregion,
} as { [key: string]: any };
